import { Controller, Get, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { RequireModule, RequirePermission } from '../../auth/decorators';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import { GetUser } from '../../auth/get-user.decorator';
import { CarteraIaService } from './cartera-ia.service';

@ApiTags('Cartera Inteligente — IA Insights')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('COBRANZAS')
@Controller({ path: 'cartera/insights', version: '1' })
export class CarteraInsightsController {
  constructor(private readonly service: CarteraIaService) {}

  @Get('resumen-dia')
  @RequirePermission('COBRANZAS', 'COB_CART_VER')
  @ApiOperation({
    summary: 'Resumen IA del día (portfolio-level)',
    description:
      'Una sola llamada IA por empresa por día. Devuelve top prioridades + alertas + salud de cartera. Cache 24h. Pasar ?refresh=true para regenerar.',
  })
  resumenDia(
    @Query('refresh') refresh: string | undefined,
    @GetUser() user: LoginUserInfo,
  ) {
    return this.service.resumenDia(user.empresa_id, {
      forceRefresh: refresh === 'true',
    });
  }
}
